await themeResource(theme.resources['mc-shopify'], false);
await themeComponent(theme.components['mc-element'], false);

// ---- GLOBAL WISHLIST FUNCTIONS ----
function updateWishlistCount() {
  const count = (window.WishListHero_SDK?.GetWishListItems?.() || []).length;
  const dots = document.querySelectorAll('.black-wishlist-dot');

  dots.forEach(dot => {
    if (count > 0) {
      dot.classList.remove('hidden');
    } else {
      dot.classList.add('hidden');
    }
  });
}

function startWishlistObserver() {
  const targetNode = document.body; // because we don’t know what DOM they’re mutating

  const config = { childList: true, subtree: true };

  const callback = (mutationsList) => {
    for (let mutation of mutationsList) {
      // Detect wishlist UI changes (like remove buttons or re-renders)
      if (
        mutation.type === 'childList' &&
        [...mutation.addedNodes].some(node => node.nodeType === 1 && node.outerHTML?.includes('wishlist'))
      ) {
        updateWishlistCount();
        document.dispatchEvent(new CustomEvent('wishlist-changed'));
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  console.log('[Wishlist Observer] Started watching DOM');
}


// ---- CUSTOM ELEMENT ----
class McWishlistHeroBtn extends McElement {
  hash;

  connectedCallback() {
    document.addEventListener("wishlist-hero-wishlist-sdk-ready", () => {
      this.init();
      startWishlistObserver();
    });
    
    document.addEventListener("wishlist-changed", () => {
      this.renderActive();
    });

    if (window.WishListHero_SDK != undefined)
      this.init();
  }

  init = () => {
    if (!this.hash) {
      this.getHash();
      return;
    }

    this.renderActive();
    updateWishlistCount();

    this.addEventListener('click', () => {
      this.toggle();
    });
    
  }

  getHash = async () => {
    this.hash = window.WishListHero_SDK.GetWishListHash();
    if (!this.hash) {
      this.hash = await window.WishListHero_SDK.GetWishListHash(true);
    }
    this.init();
  }

  addToWishlist = () => {
    if (!this.hash) { console.error('No wishlist hash found'); return; }
    if (!this.dataset.wsId) { console.error('No wishlist item ID found'); return; }
    if (!this.dataset.wsVariant) { console.error('No wishlist item variant ID found'); return; }
    if (!this.dataset.wsTitle) { console.error('No wishlist item title found'); return; }
    if (!this.dataset.wsPrice) { console.error('No wishlist item price found'); return; }
    if (!this.dataset.wsLink) { console.error('No wishlist item link found'); return; }
    if (!this.dataset.wsImage) { console.error('No wishlist item image found'); return; }

    const config = {
      CustomerId: window.WishListHero_SDK.GetCustomerId() || undefined,
      ProductId: this.dataset.wsId,
      ProductTitle: this.dataset.wsTitle,
      ProductPrice: this.dataset.wsPrice,
      ProductLink: this.dataset.wsLink,
      ProductVariantId: this.dataset.wsVariant,
      ProductImage: this.dataset.wsImage,
      WishlistHash: this.hash
    };

    window.WishListHero_SDK.AddWishListItem(config).then(a => {
      if (!a.ok) throw new Error('Failed to add item to wishlist');
      this.renderActive();
      updateWishlistCount(); // 🔥 update counter
      document.dispatchEvent(new CustomEvent('wishlist-changed')); // 📣 notify everyone
      McShopify.customEvent(MCEVENTS.WISHLIST_ADDED, {
        variantId: this.dataset.wsVariant
      });
    }).catch(e => {
      console.error('Error adding to wishlist', e);
      McShopify.customEvent(MCEVENTS.WISHLIST_ERROR, {
        error: e.message || e,
        variantId: this.dataset.wsVariant
      });
    });
  }

  removeFromWishlist = () => {
    if (!this.hash) { console.error('No wishlist hash found'); return; }
    if (!this.dataset.wsVariant) { console.error('No wishlist item variant ID found'); return; }

    const config = {
      ProductVariantId: this.dataset.wsVariant,
      WishlistHash: this.hash
    };

    window.WishListHero_SDK.DeleteWishListItem(config).then(a => {
      this.renderActive();
      updateWishlistCount(); // 🔥 update counter
      document.dispatchEvent(new CustomEvent('wishlist-changed')); // 📣 notify everyone
      McShopify.customEvent(MCEVENTS.WISHLIST_REMOVED, {
        variantId: this.dataset.wsVariant
      });
    }).catch(e => {
      console.error('Error removing from wishlist', e);
      McShopify.customEvent(MCEVENTS.WISHLIST_ERROR, {
        error: e.message || e,
        variantId: this.dataset.wsVariant
      });
    });
  }

  toggle = () => {
    this.isActive() ? this.removeFromWishlist() : this.addToWishlist();
  }

  isActive = () => {
    const wishlistItems = window.WishListHero_SDK.GetWishListItems();
    return wishlistItems.some(item => item.ProductVariantId == this.dataset.wsVariant);
  }

  renderActive = () => {
    if (this.isActive()) {
      this.activate();
    } else {
      this.deactivate();
    }
  }
}

// ---- REGISTER ELEMENT ----
if (!customElements.get('mc-wishlist-hero-btn')) {
  customElements.define('mc-wishlist-hero-btn', McWishlistHeroBtn);
  //McUtils.addCss(`https://cdn.jsdelivr.net/npm/ict-shopify@${McUtils.VERSION}/v2/css/mc-wishlist-hero-btn.css`);
}

window.McWishlistHeroBtn = McWishlistHeroBtn;
export default McWishlistHeroBtn;
